export default {
	SET_EVENTS(state, payload) {
		state.events = payload.data;
		state.totalEvents = payload.total;
	},
	SET_EVENTS_VIOLATION(state, payload) {
		state.eventsViolation = payload.data;
		state.totalEventsViolation = payload.total;
	}
};
